let discount__svg = `<svg class="svg-icon icon-sale-tag " xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 350 350" fill="none">
    <path d="M14.1105 184.325L20.4325 190.654L20.4364 190.65L14.1105 184.325ZM179.23 19.2054L172.904 12.8794L172.904 12.8795L179.23 19.2054ZM203.87 9L203.87 17.9461H203.87V9ZM341 146.13L332.054 146.13L332.054 146.13L341 146.13ZM330.795 170.77L337.121 177.096L337.121 177.096L330.795 170.77ZM165.675 335.889L159.35 329.564L159.346 329.567L165.675 335.889ZM141.021 335.889L147.351 329.567L147.347 329.564L141.021 335.889ZM14.1105 208.979L20.4364 202.653L20.4325 202.649L14.1105 208.979ZM7.78857 177.995C2.83646 182.941 0.0538931 189.653 0.0538931 196.652H17.9461C17.9461 194.402 18.8406 192.244 20.4325 190.654L7.78857 177.995ZM172.904 12.8795L7.78469 177.999L20.4364 190.65L185.556 25.5312L172.904 12.8795ZM203.87 0.0538931C192.256 0.0534675 181.117 4.66693 172.904 12.8794L185.555 25.5314C190.413 20.6744 197 17.9459 203.87 17.9461L203.87 0.0538931ZM326.565 0.0538931H203.87V17.9461H326.565V0.0538931ZM349.946 23.4348C349.946 10.5219 339.478 0.0538931 326.565 0.0538931V17.9461C329.597 17.9461 332.054 20.4035 332.054 23.4348H349.946ZM349.946 146.13V23.4348H332.054V146.13H349.946ZM337.121 177.096C345.333 168.883 349.947 157.744 349.946 146.13L332.054 146.13C332.054 153 329.326 159.587 324.469 164.445L337.121 177.096ZM172.001 342.215L337.121 177.096L324.469 164.444L159.35 329.564L172.001 342.215ZM153.348 349.946C160.347 349.946 167.059 347.164 172.005 342.211L159.346 329.567C157.756 331.159 155.598 332.054 153.348 332.054V349.946ZM134.691 342.211C139.637 347.164 146.349 349.946 153.348 349.946V332.054C151.098 332.054 148.941 331.159 147.351 329.567L134.691 342.211ZM7.78469 215.305L134.695 342.215L147.347 329.564L20.4364 202.653L7.78469 215.305ZM0.0538931 196.652C0.0538931 203.651 2.83647 210.363 7.78857 215.309L20.4325 202.649C18.8406 201.059 17.9461 198.902 17.9461 196.652H0.0538931ZM276.043 104.555C292.942 104.555 306.642 90.8558 306.642 73.9569H288.75C288.75 80.9742 283.061 86.6629 276.043 86.6629V104.555ZM245.445 73.9569C245.445 90.8558 259.145 104.555 276.043 104.555V86.6629C269.026 86.6629 263.337 80.9742 263.337 73.9569H245.445ZM276.043 43.3586C259.145 43.3586 245.445 57.0579 245.445 73.9569H263.337C263.337 66.9395 269.026 61.2508 276.043 61.2508V43.3586ZM306.642 73.9569C306.642 57.0579 292.942 43.3586 276.043 43.3586V61.2508C283.061 61.2508 288.75 66.9395 288.75 73.9569H306.642Z" fill="currentColor"></path>
  </svg>`;

const debounceNote = (func, delay) => {
    let debounceTimer
    return function () {
        const context = this
        const args = arguments
        clearTimeout(debounceTimer)
        debounceTimer = setTimeout(() => func.apply(context, args), delay)
    }
}
const onSkeleton = () => {
    $('#loading-skeleton').show();
    $('#lineItemList').hide();
}
const offSkeleton = () => {
    $('#loading-skeleton').hide();
    $('#lineItemList').show();
}


console.log('Ajax Connected');
const cartDrawer = $("#cartDrawerContainer");
function fetchCart(){
    //loading
    fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(data => {
        cartTemplate(data);
        console.log(data);
    });
}
const toggleDrawer = () => {
    if ($(".cart-drawer-container .main-drawer").hasClass("hidden-drawer")) {
        cartDrawer.show();
        fetchCart();
        setTimeout(() => {
            $(".cart-drawer-container .main-drawer").removeClass("hidden-drawer");
            $(".cart-drawer-container .main-drawer").addClass("open-drawer");
            $('body').addClass('ajax-cart-active');
        }, 100)

    } else {
        $(".cart-drawer-container .main-drawer").addClass("hidden-drawer");
        $(".cart-drawer-container .main-drawer").removeClass("open-drawer");
        $('body').removeClass('ajax-cart-active');
        setTimeout(() => {
            cartDrawer.hide();
        }, 500)
    }

}


$(".ajax-cart-switch").click(function () {
    toggleDrawer();
});
$(".close-cart").click(function () {
    toggleDrawer();
});


$("#quantity-form").submit(function (e) {
    e.preventDefault();
});


// ajax 
let cartItems = [];
let cartNote = '';
let cartCount = '';

//update note
const setCartNote = async (note) => {
    let noteData = {
        note
    }
    return await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: "POST",
        body: JSON.stringify(noteData),
        headers: {
            "Content-Type": "application/json"
        }
    }).then(response => response.json())
}

$("#cartNote").on('input', debounceNote(function () {
    let note = $('#cartNote').val();
    setCartNote(note).then(data => {
        // console.log(data);
    });
}, 1000));

// reset cart
const splitPrice = (price) => {
    let negative = false,
        moneyValue = price;
    let priceArray = moneyValue.toString().split("")

    if (priceArray[0] === "-") {
        priceArray.shift();
        moneyValue = parseInt(priceArray.join("").replace(/,/g, ""))
        negative = true
    }

    let priceValue = Math.floor(moneyValue / 100),
        floatPoint = moneyValue % 100;
    let priceSplit = [];

    if (priceValue.toString().split("").length > 3) {
        priceSplit = priceValue.toString().split("");
        let splitJump = 3,
            splitPoint = priceSplit.length % splitJump,
            splitIndex = splitPoint === 0 ? splitJump - 1 : splitPoint - 1;

        priceSplit = priceSplit.map((value, valueIndex) => {
            if (valueIndex === splitIndex && valueIndex !== priceSplit.length - 1) {
                value = `${value},`
                splitIndex += splitJump
            }

            return value;
        })

        priceValue = priceSplit.join("+").replace(/\+/g, "");
    }

    if (negative) {
        priceValue = `-${priceValue}`
    }
    if (floatPoint.toString().length === 1) {
        floatPoint = `${floatPoint}0`
    }
    return `${priceValue}.${floatPoint}`
}

function setCartValues(totalItems, priceTotal) {
    cartCount = totalItems;
    totalCartAmount = splitPrice(priceTotal);
    if (cartCount == 0) {
        $(".ajax-cart-count").hide();
    } else {
        $('.ajax-cart-count').show();
        $('.ajax-cart-count').html('' + cartCount);
    }
    $('#subtotalCart').html('$' + totalCartAmount);
}

//base or cart template for starting point
function cartTemplate(data) {
    let finalPrice
    document.querySelector('#lineItemList').innerHTML = '';
    cartItems = data.items;
    cartNote = data.note;
    
    $("#cartNote").val(cartNote);
    setCartValues(data.item_count, data.total_price);
    //add if condition for cart=0 and show ele - cart is empty
    if (data.item_count > 0){
        data.items.forEach((element, index) => {
          // discount 
          if(element.discounts.length > 0){
            element.discounts.forEach((ele, index)=>{
             discountAmount = ele.amount
              discountTitle = ele.title;
              if(discountAmount == 0){
                finalPrice = `<span>${discount__svg} ${discountTitle}</span> </br> $${ splitPrice(element.price)}`
              } else{
                console.log('&&&&&& ' + element.final_line_price + 'amount - ' + ele.amount)
                finalPrice = `<span>${discount__svg} ${discountTitle}</span> </br> <strike> $${ splitPrice(element.price)}</strike> $ ${splitPrice(element.final_price)} `
              }
            });
          } else{
              finalPrice = `$${ splitPrice(element.price)}`
          }
        // end discount 
          
            const liteItem = `
                    <li class="cart-line-item loading-view" data-index="${index}" data-variant="${element.variant_id}">
                        <div class="item-image"><img
                                src="${ element.image }" width="30" height="30" loading="lazy" />
                        </div>
                        <div class="item-details">
                            <div class="item-title"><a href="${ element.url }">${ element.product_title }</a></div>
                            <div class="variant-item"><p>${ element.variant_title == null ? '' : element.variant_title }</p></div>
                            <div class="quantity-selector">
                                
                                <form class="selector-group" id="quantity-form">
                                    <button class="selection-change quantity-decrease">
                                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"
                                            role="presentation" class="icon icon-minus" fill="none" viewBox="0 0 10 2">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor">
                                            </path>
                                        </svg>
                                    </button>
                                        <input type="text" value="${ element.quantity }" class="quantity-select quantity-count">
                                        <input type="submit" value="submit" hidden>
                                        <button class="selection-change quantity-increase">
                                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"
                                            role="presentation" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z"
                                                fill="currentColor">
                                            </path>
                                        </svg>
                                    </button>
                                </form>
                               
                            </div>
                        </div>
                        <div class="item-actions">
                            <span class="remove-item"><a href="javascript:void(0)">
                            <?xml version="1.0" encoding="utf-8"?>
    <!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 15.47 15.86" style="enable-background:new 0 0 15.47 15.86;" xml:space="preserve">
    <style type="text/css">
        .st0{fill:#FBE8DB;}
        .st1{fill:#81BCE9;}
        .st2{fill:#FFFFFF;}
        .st3{opacity:0.18;}
        .st4{clip-path:url(#SVGID_00000039093320327047512990000012703828678121990297_);}
        .st5{fill:none;stroke:#000000;stroke-miterlimit:10;}
        .st6{clip-path:url(#SVGID_00000107549391378316589120000009044951910067381929_);}
        .st7{fill:#F1C8A8;}
        .st8{fill:none;stroke:#F1C8A8;stroke-width:1.5;stroke-miterlimit:10;}
        .st9{clip-path:url(#SVGID_00000099643737699008911070000000701281062246926244_);}
        .st10{clip-path:url(#SVGID_00000085212995217786976640000012992577422661445803_);}
        .st11{opacity:0.5;fill:#FFFFFF;}
    </style>
    <g id="Calque_1">
        <g>
            <g>
                <g>
                    <g>
                        <path d="M1.07,1.76c4.09,4.2,8.18,8.39,12.26,12.59c0.67,0.69,1.73-0.37,1.06-1.06C10.31,9.1,6.22,4.9,2.13,0.7
                            C1.46,0.01,0.4,1.07,1.07,1.76L1.07,1.76z"/>
                    </g>
                </g>
                <g>
                    <g>
                        <path d="M3.16,15.07c3.41-4.47,6.82-8.95,10.23-13.42c0.58-0.77-0.72-1.52-1.3-0.76C8.69,5.36,5.28,9.83,1.87,14.31
                            C1.28,15.08,2.58,15.82,3.16,15.07L3.16,15.07z"/>
                    </g>
                </g>
            </g>
        </g>
    </g>
    <g id="Mode_Isolation">
    </g>
    </svg>
    
                            </a></span>
                            <div class="item-price">${ finalPrice }</div>
                        </div>
                    </li>
                    `;
            offSkeleton();
            document.querySelector('#lineItemList').innerHTML += liteItem;
        });
    } else{
        offSkeleton();
        $('#lineItemList').append(`<div class="empty-cart">No items in your cart.</div>`);
    }
  
}

// fetch cart item when site loads
fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(data => {
        cartTemplate(data);
        console.log(data);
    });

// update cart 
const updateCart = async (variantId, value) => {
    let requestObject = {}
    requestObject[`${variantId}`] = value
    let object = {
        updates: requestObject
    }
    return await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: "POST",
        body: JSON.stringify(object),
        headers: {
            "Content-Type": "application/json"
        }
    }).then(data => { fetchCart() }).then(response => response.json())
}

//remove item
$(document).on('click', '.remove-item', function () {
    onSkeleton();
    let index = $(".remove-item").index(this);
    updateCart(cartItems[index].variant_id, 0)
        .then(data => {
            setCartValues(data.item_count, data.total_price);
            cartTemplate(data);
        });
});


//quantity decrease
$(document).on('click', '.quantity-decrease', function (e) {
    e.preventDefault();
    let index = $(".quantity-decrease").index(this);
    // console.log(index);
    // console.log(cartItems[index]);
    // console.log(cartItems);
    
    if(cartItems[index].quantity > 0){
        cartItems[index].quantity -= 1
        $('.quantity-count').eq(index).val(cartItems[index].quantity);
        updateCart(cartItems[index].variant_id, cartItems[index].quantity).then(data => {
        setCartValues(data.item_count, data.total_price);
        if (cartItems[index].quantity == 0) {
            onSkeleton();
            cartTemplate(data);
        }
        })
    }
    
});

//quantity increase
$(document).on('click', '.quantity-increase', function (e) {
    e.preventDefault();
    let index = $(".quantity-increase").index(this);
    cartItems[index].quantity += 1
    $('.quantity-count').eq(index).val(cartItems[index].quantity);
    updateCart(cartItems[index].variant_id, cartItems[index].quantity).then(data => {
        setCartValues(data.item_count, data.total_price);
    })
});

// add to cart 
const addToCart = async (id, quantity) => {
    const items = [{
        id,
        quantity
    }]
    return await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: JSON.stringify({
            items
        }),
        headers: {
            "Content-Type": "application/json"
        }
    }).then(response => response.json()).then(data => {
        fetchCart();
    })
}
$('form[action = "/cart/add"]').submit(function (e) {
    e.preventDefault();
    // console.log(e);
});

$('.promo-item-btn__cart').click(function(){
    onSkeleton();
    variantId = $(this).data('id');
    console.log(variantId);
    addToCart(variantId, 1).then(data => {
        fetchCart();
        offSkeleton();
    });
});

$('.continueLink').click(function(){
    toggleDrawer();
});

$('#cartDrawerContainer').on("click", function (e) {
    if (e.target.closest(".main-drawer") == null) {
      if (!$(".cart-drawer-container .main-drawer").hasClass("hidden-drawer")) {
          toggleDrawer();
      }
    }
});
  
$('.ajax-cart-count').on('change', function(){

  this.cartAjax = document.querySelector('.ajax-cart-switch');
  //ajax cart update on add-to-cart
  this.cartAjax.click();
  onSkeleton();
  
});

